import loadProductComparisonModule from './modules/ProductComparison.module';
import loadCompareModule from './modules/Compare.module';
import loadDeliveryPromiseModule from './modules/DeliveryPromise.module';
const loadProductComparisonRootModule = () => ({
    hasRouter: false,
    modules: [loadProductComparisonModule(), loadCompareModule(), loadDeliveryPromiseModule()],
});
export default loadProductComparisonRootModule;
